<template>
  <div class="table-hover  mb-1 table-page-responsive table-ellipsis">
    <table class="table align-middle">
      <thead class="table-light">
        <tr>
          <th scope="col" style="width: 5px">
            <div class="form-check">
              <input
                v-model="showAllChecked"
                class="form-check-input"
                type="checkbox"
                id="checkAll"
                @change="checkAllChanged($event)"
              />
            </div>
          </th>
          <th
            scope="col"
            v-for="(th, i) in column"
            :key="i"
            style="padding-left: 20px"
            :style="th.width && { width: th.width }"
          >
            {{ th.title }}
          </th>
          <th style="width: 300px; padding-left: 20px">
            {{ this.$t("page.health-monitoring.threshold_interval_diagram") }}
          </th>
          <th style="padding-left: 20px">
            {{ this.$t("page.health-monitoring.historical_data") }}
          </th>
        </tr>
      </thead>
      <tbody class="list">
        <tr v-for="(item, index) in showTableData" :key="index">
          <th scope="row">
            <div class="form-check">
              <input
                style="margin-bottom: 4px"
                class="form-check-input"
                v-model="item.checked"
                type="checkbox"
                name="chk_child"
                @change="singleChecked($event, item.id)"
              />
            </div>
          </th>
          <td
            v-for="th in column"
            :key="th.dataIndex"
            scope="col"
            style="padding-left: 20px"
          >
            <div
              v-if="th.dataIndex == 'warn_status'"
              :class="`status-icon status-icon-${
                item[th.dataIndex] || 'unknown'
              }`"
            ></div>
            <span v-else-if="th.dataIndex == 'ts'">
              {{
                (item[th.dataIndex] &&
                  moment(item[th.dataIndex])
                    .tz($tz)
                    .format("YYYY-MM-DD HH:mm:ss")) ||
                "-"
              }}
            </span>
            <span
              v-else-if="th.dataIndex == 'curvalue'"
              v-text="valueFormatter1(item[th.dataIndex])"
            ></span>
            <span v-else> {{ item[th.dataIndex] }} </span>
          </td>
          <!-- <td
            :id="item.eqId + item.key"
            style="
              height: 100px;
              width: 200px;
              padding-left: 20px;
              max-width: 12.5rem;
            "
          ></td> -->
          <td>
            <div
              style="
                width: 200px;
                background-color: #c8d1d7;
                border-radius: 2px;
                height: 10px;
              "
              class="d-flex position-relative"
              v-if="item "
            >
              <div
                v-if="item && item.curvalue !== '' && threshold(item)"
                class="d-flex flex-wrap align-items-center justify-content-between position-absolute"
                :style="{
                  top: '-22px',
                  left: curvalueFormat(item),
                  transition: 'left 1s',
                  width: '100px',
                }"
              >
                <div class="w-100 text-center fs-12" style="line-height: 12px">
                  {{ item && item.curvalue }}
                </div>
                <div class="w-100 d-flex justify-content-center">
                  <i
                    class="bx bxs-down-arrow"
                    style="color: #6e7080; font-size: 12px"
                  ></i>
                </div>
              </div>
              <!-- 健康 -->
              <el-popover
                placement="bottom-start"
                title=""
                :width="150"
                trigger="hover"
                :disabled="item && (item.curvalue ==0?item.curvalue:!item.curvalue)"
              >
                <template #reference>
                  <div
                    v-if="item && item.curvalue !== '' && threshold(item)"
                    style="width: 34%; background-color: #6da51e; height: 10px"
                  ></div>
                </template>
                <div>
                  {{
                    Number(item.standardThresholdLow) +
                    "≤x≤" +
                    Number(item.standardThresholdHigh)
                  }}
                </div>
              </el-popover>
              <!-- 亚健康 -->
              <el-popover
                placement="bottom-start"
                title=""
                :width="250"
                trigger="hover"
                :content="
                  `${Number(item.operationThresholdLow)}` +
                  '<x<' +
                  `${Number(item.standardThresholdLow)}` +
                  ' or ' +
                  `${Number(item.standardThresholdHigh)}` +
                  '<x<' +
                  `${Number(item.operationThresholdHigh)}`
                "
                :disabled="item && (item.curvalue ==0?item.curvalue:!item.curvalue)"
              >
                <template #reference>
                  <div
                    v-if="item && item.curvalue !== '' && threshold(item)"
                    style="width: 33%; background-color: #f6c545; height: 10px"
                  ></div>
                </template>
              </el-popover>

              <!-- 危险 -->
              <el-popover
                placement="bottom-start"
                title=""
                :width="200"
                trigger="hover"
                :content="
                  'x≤' +
                  `${Number(item.operationThresholdLow)}` +
                  ' or ' +
                  'x≥' +
                  `${Number(item.operationThresholdHigh)}`
                "
                :disabled="item && (item.curvalue ==0?item.curvalue:!item.curvalue)"
              >
                <template #reference>
                  <div
                    v-if="item && item.curvalue !== '' && threshold(item)"
                    style="width: 33%; background-color: #d9716d; height: 10px"
                  ></div>
                </template>
              </el-popover>
            </div>
          </td>
          <td style="padding-left: 20px">
            <i
              class="mdi mdi-20px fs-20 mdi-chart-areaspline text-primary"
              @click="goHistory(item)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { progressChart } from "../../utils/chart";
import moment from "moment";
import "moment-timezone";
import { valueFormatter1 } from "../../utils/common";
export default {
  emits: ["update:singleData", "checkAllChanged", "singleChecked"],
  props: {
    singleData: Object,
    allCheckedType: Boolean,
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    column: {
      type: Array,
      default: () => {
        return [];
      },
    },
    measurementsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    refresh_frequency: {
      type: Number,
      default: () => {
        return 3;
      },
    },
  },
  components: {},
  data() {
    return {
      showTableData: [],
      showAllChecked: false,
      states: {
        unknown: "#9ca3bf",
        error: "#ED5E5E",
        health: "#13C56B",
        "sub-health": "#f7b84b",
      },
    };
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.showTableData = newVal;
        // this.$nextTick(() => {
        //   this.showTableData.map((item) => {
        //     progressChart({
        //       chartDom: document.getElementById(item.eqId + item.key),
        //       dataList: item,
        //       lineColor: this.states[item["warn_status"]],
        //     });
        //   });
        // });
      },
      deep: true,
    },
    allCheckedType: {
      handler(newVal) {
        this.showAllChecked = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    threshold(item) {
      let o1 = Number(item.operationThresholdLow);
      let o2 = Number(item.operationThresholdHigh);
      let s1 = Number(item.standardThresholdLow);
      let s2 = Number(item.standardThresholdHigh);
      let flag = true;
      if (s1 < o1 || s2 > o2) {
        flag = false;
      }

      return flag;
    },
    curvalueFormat(item) {
      if (item && (item.curvalue||item.curvalue===0)) {
        let c = item.curvalue;
        let o1 = item.operationThresholdLow;
        let o2 = item.operationThresholdHigh;
        let s1 = item.standardThresholdLow;
        let s2 = item.standardThresholdHigh;
        if (((c||c===0) && o1 && o2 && s1 && s2) ) {
          if (c <= o1 || c >= o2) {
            if (c <= o1) {
              return "43%";
            }
            if (c >= o2) {
              return "73%";
            }
          } else if (s1 <= c && c <= s2) {
            return (c - s1) / ((s2 - s1) / 34) - 25 + "%";
          } else if (c > o1 && c < s1) {
            return Math.abs((c - s1) / ((o1 - s1) / 16)) + 20 + "%";
          } else if (c > s2 && c < o2) {
            return (c - s2) / ((o2 - s2) / 15) + 26 + "%";
          } else {
            return null;
          }
        } else {
          return null;
        }
      }
    },
    valueFormatter1,
    moment,
    goHistory(item) {
      var obj = this.measurementsList.filter((o) => {
        return o.id == item.eqId && o.name == item.eqName;
      });
      localStorage.setItem("equipmentData", JSON.stringify(...obj));
      localStorage.setItem("historyData", JSON.stringify([item]));
      if (obj[0].parent_id) {
        sessionStorage.setItem("deviceTreeActive", obj[0].parent_id);
      } else {
        sessionStorage.setItem("deviceTreeActive", obj[0].id);
      }

      sessionStorage.setItem("deviceTreeActive",item.id);
      this.$router.push("/iot/atlas-analysis");
    },
    checkAllChanged() {
      this.$emit("checkAllChanged", this.showAllChecked);
    },
    singleChecked(ev, id) {
      this.$emit("singleChecked", id, ev.target.checked);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.showTableData.map((item) => {
        progressChart({
          chartDom: document.getElementById(item.eqId + item.key),
          dataList: item,
        });
      });
    });
  },
};
</script>

<style lang="scss" scoped></style>
